import { classNames } from 'shared/lib/classNames/classNames'
import cls from './DragDrop.module.scss'
import { Text, TextAlign, TextSize, TextWeight } from 'shared/ui/Text/Text'
import { Link } from 'react-router-dom'
import {
    ideasUrl,
    openExternalUrl,
    supportUrl,
} from 'shared/config/externalLinks'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { AccountAccessDialog } from 'features/emailAuth'
import {
    AdminIcon,
    ArchiveIcon,
    EditIcon,
    IdeaIcon,
    LogoutIcon,
    SupportIcon,
} from 'shared/ui/Icon'

export const DragDrop = (props) => {
    const {
        accountLinked,
        className,
        closeDragdrop,
        onAccountChanged,
        onAccountLinked,
    } = props
    const isAdmin = useSelector((state) => state.auth.isAdmin)
    const [accountDialogOpen, setAccountDialogOpen] = useState(false)

    // const copyText = (text) => {
    // 	copyTextToClipboard(text)
    // 	closeDragdrop()
    // 	onSpeak()
    // }

    // const shareProfile = () => {
    // 	shareFunc()
    // 	closeDragdrop()
    // }

    const toHelp = () => {
        openExternalUrl(supportUrl)
    }

    const suggestIdea = () => {
        if (openExternalUrl(ideasUrl)) {
            closeDragdrop()
        }
    }

    return (
        <div className={classNames(cls.DragDrop, {}, [className])}>
            <div
                className={cls.background}
                onMouseDown={closeDragdrop}
                onTouchStart={closeDragdrop}
            />
            <div className={cls.Wrapper}>
                {isAdmin ? (
                    <>
                        <Link
                            to="/admin"
                            className={cls.item}
                            onClick={closeDragdrop}
                        >
                            <Text
                                className={cls.text}
                                size={TextSize.S}
                                align={TextAlign.LEFT}
                                weight={TextWeight.SBOLD}
                            >
                                Админка
                            </Text>
                            <AdminIcon className={cls.icon} />
                        </Link>
                        <div className={cls.lineBold} />
                    </>
                ) : null}
                <Link to="/settings" className={cls.item}>
                    <Text
                        className={cls.text}
                        size={TextSize.S}
                        align={TextAlign.LEFT}
                        weight={TextWeight.SBOLD}
                    >
                        Редактировать профиль
                    </Text>
                    <EditIcon className={cls.icon} />
                </Link>
                <div className={cls.line} />
                <Link
                    to="/archive"
                    className={cls.item}
                    onClick={closeDragdrop}
                >
                    <Text
                        className={cls.text}
                        size={TextSize.S}
                        align={TextAlign.LEFT}
                        weight={TextWeight.SBOLD}
                    >
                        Архив достижений
                    </Text>
                    <ArchiveIcon className={cls.icon} />
                </Link>
                <div className={cls.line} />
                <button
                    className={cls.item}
                    onClick={suggestIdea}
                    type="button"
                >
                    <Text
                        className={cls.text}
                        size={TextSize.S}
                        align={TextAlign.LEFT}
                        weight={TextWeight.SBOLD}
                    >
                        Предложить идею для приложения
                    </Text>
                    <IdeaIcon className={cls.icon} />
                </button>
                {supportUrl ? (
                    <>
                        <div className={cls.line} />
                        <div onClick={toHelp} className={cls.item}>
                            <Text
                                className={cls.text}
                                size={TextSize.S}
                                align={TextAlign.LEFT}
                                weight={TextWeight.SBOLD}
                            >
                                Написать в поддержку
                            </Text>
                            <SupportIcon className={cls.icon} />
                        </div>
                    </>
                ) : null}
                <div className={cls.line} />
                <button
                    className={cls.item}
                    onClick={() => setAccountDialogOpen(true)}
                    type="button"
                >
                    <Text
                        className={cls.text}
                        size={TextSize.S}
                        align={TextAlign.LEFT}
                        weight={TextWeight.SBOLD}
                    >
                        Выйти / сменить аккаунт
                    </Text>
                    <LogoutIcon className={cls.icon} />
                </button>
                {/* <div onClick={() => copyText(nickname ? `@${nickname}` : `@${id}`)} className={cls.item}>
                    <Text
                        className={cls.text}
                        size={TextSize.S}
                        align={TextAlign.LEFT}
                        weight={TextWeight.SBOLD}
                    >
                        Скопировать ник
                    </Text>
                    <img className={cls.icon} src={copy} alt="edit"></img>
                </div>
                <div className={cls.line}></div> */}
                {/* <Link to="/friends" className={cls.item}>
                    <Text
                        className={cls.text}
                        size={TextSize.S}
                        align={TextAlign.LEFT}
                        weight={TextWeight.SBOLD}
                    >
                        Сохраненные профили
                    </Text>
                    <img className={cls.icon} src={bookmark} alt="edit"></img>
                </Link> */}
                {/* <div onClick={shareProfile} className={cls.item}>
                    <Text
                        className={cls.text}
                        size={TextSize.S}
                        align={TextAlign.LEFT}
                        weight={TextWeight.SBOLD}
                    >
                        Поделиться профилем
                    </Text>
                    <img className={cls.icon} src={share} alt="edit"></img>
                </div> */}
            </div>
            <AccountAccessDialog
                linked={accountLinked}
                onAccountChanged={(result) => {
                    setAccountDialogOpen(false)
                    closeDragdrop()
                    onAccountChanged?.(result)
                }}
                onClose={() => setAccountDialogOpen(false)}
                onLinked={onAccountLinked}
                open={accountDialogOpen}
            />
        </div>
    )
}
